import React from 'react';

const StatusBadge = ({ status }) => {
    const getStatusClass = (s) => {
        switch (s?.toLowerCase()) {
            case 'published':
                return 'status-published';
            case 'pending_review':
            case 'in_review_stakeholder':
                return 'status-pending';
            case 'stakeholder_approved':
                return 'status-pending'; // Or a new green-ish class
            case 'rejected':
                return 'status-rejected';
            case 'draft':
            default:
                return 'status-draft';
        }
    };

    const getLabel = (s) => {
        switch (s?.toLowerCase()) {
            case 'published': return 'Live';
            case 'pending_review': return 'In Review';
            case 'in_review_stakeholder': return 'UAT Review';
            case 'stakeholder_approved': return 'UAT Approved';
            case 'rejected': return 'Changes Requested';
            case 'draft': return 'Draft';
            default: return 'Draft';
        }
    };

    return (
        <span className={`status-badge-pill ${getStatusClass(status)}`}>
            {getLabel(status)}
        </span>
    );
};

export default StatusBadge;